module.exports = __webpack_public_path__ + "img/40.ab0626e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40.png
// module id = 929
// module chunks = 2